module.exports = __webpack_public_path__ + "img/clint-mckoy.7f85ec6f.jpg";